module.exports = __webpack_public_path__ + "img/MPI_CBG_Logo_horizontal_black.d763787e.png";